import Vue from 'vue'
import VueRouter from 'vue-router'
import publicRoutes from './modules/public'
import adminRoutes from './modules/admin'
import { createBeforeEachGuard } from './permission'

Vue.use(VueRouter)

const routes = [
  ...publicRoutes,
  ...adminRoutes,
  {
    path: '*',
    redirect: '/admin/home'
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(createBeforeEachGuard())

export default router
